export default defineNuxtPlugin(() => {
  const { $eventBus } = useNuxtApp()
  const { vehicleGps } = $store()
  const vehicle = {
    setGPS: (info: any) => {
      vehicleGps.setVehicle(info)
      $eventBus.emit('vehicleChange', info)
    }
  }
  return {
    provide: {
      vehicle
    }
  }
})
